export const CURRENT_WORKSPACE_ID_STORAGE_KEY = 'welya.currentWorkspaceId';

export function getStoredWorkspaceId(): number | null {
  if (typeof window === 'undefined') return null;
  try {
    const raw = localStorage.getItem(CURRENT_WORKSPACE_ID_STORAGE_KEY);
    if (raw === null) return null;
    const id = Number(raw);
    return Number.isNaN(id) ? null : id;
  } catch {
    return null;
  }
}

export interface StoredWorkspaceRestoreInput {
  hasCurrentWorkspace: boolean;
  storedId: number | null;
  loadedIds: number[];
  totalPages: number;
}

/**
 * La liste ne charge qu'une page triée par nom : un compte à plus d'une page (support) peut avoir
 * mémorisé un workspace absent de la première. Renvoie l'id à charger à part, `null` sinon.
 */
export function storedWorkspaceIdToRestore({
  hasCurrentWorkspace,
  storedId,
  loadedIds,
  totalPages,
}: StoredWorkspaceRestoreInput): number | null {
  if (hasCurrentWorkspace || storedId == null) {
    return null;
  }
  if (loadedIds.includes(storedId)) {
    return null;
  }
  return totalPages > 1 ? storedId : null;
}
